import { jsx as a } from "react/jsx-runtime";
import { useState as s, useMemo as n, useCallback as m } from "react";
const g = ({ src: o, children: t }) => {
  const [r, l] = s(!1), z = n(() => {
    var e;
    if (t && t.length <= 2)
      return t;
    const u = (t ?? "u").split(" ");
    return `${u[0][0]}${u.length > 1 ? ((e = u[u.length - 1]) == null ? void 0 : e[0]) ?? "" : ""}`.trim();
  }, [t]), i = m(() => l(!0), []);
  return /* @__PURE__ */ a("div", { className: "uizz-layout-flex uizz-layout-h-7 uizz-layout-w-7 uizz-layout-items-center uizz-layout-justify-center uizz-layout-overflow-hidden uizz-layout-rounded-[50%] uizz-layout-bg-[var(--eduzz-theme-primary)] uizz-layout-text-xs uizz-layout-text-white", children: o && !r ? /* @__PURE__ */ a("img", { src: o, onError: i, className: "uizz-layout-max-h-full uizz-layout-max-w-full" }) : z });
};
export {
  g as default
};
//# sourceMappingURL=index.js.map
